import {ref} from "vue";

let lastTic = ref(null);

export function saveLastTic(tic) {
    lastTic.value = parseInt(tic, 10);
}

export function getLastTic() {
    if (lastTic.value === null) {
        return null;
    }
    return padTicNumber(lastTic.value);
}

export function getNextTic() {
    if (lastTic.value === null) {
        return null;
    }
    return padTicNumber(lastTic.value + 1);
}

function padTicNumber(number) {
    return number.toString().padStart(4, '0');
}
